import { render, staticRenderFns } from "./ReviewOrdersDonutByStatus.vue?vue&type=template&id=2a29bd18"
import script from "./ReviewOrdersDonutByStatus.vue?vue&type=script&lang=js"
export * from "./ReviewOrdersDonutByStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports